import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import MenuItems from './MenuItems';
// import Items from './Items.json';
import { history } from '../../helpers/history';
import MenuHeader from './MenuHeader';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import { useTheme, makeStyles, Typography } from '@material-ui/core';
import { sendMobile } from '../../functions/mobile';
// import { isMobile } from 'react-device-detect';


const drawerWidth = 270;
const drawerWidthMobile = 300;

const useStyles = makeStyles((theme) => ({
  drawer: {
    borderRight: "unset",
    [theme.breakpoints.up('sm')]: {
      width: drawerWidthMobile,
      flexShrink: 0,
      // backgroundColor: '#fff'
    },
    [theme.breakpoints.up('md')]: {
      width: drawerWidth,
      flexShrink: 0,
      // backgroundColor: '#fff'
    },
    [theme.breakpoints.up('lg')]: {
      width: drawerWidth,
      flexShrink: 0,
      // backgroundColor: '#fff'
    },
    [theme.breakpoints.up('xl')]: {
      width: drawerWidth,
      flexShrink: 0,
      // backgroundColor: '#fff'
    },
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    borderRight: "unset",
    [theme.breakpoints.up('xs')]: {
      width: drawerWidthMobile,
      // backgroundColor: "#fff"
    },
    [theme.breakpoints.up('sm')]: {
      width: drawerWidthMobile,
      // backgroundColor: "#fff"
    },
    [theme.breakpoints.up('md')]: {
      width: drawerWidth,
      // backgroundColor: "#fff"
    },
    [theme.breakpoints.up('lg')]: {
      width: drawerWidth,
      // backgroundColor: "#fff"
    },
    [theme.breakpoints.up('xl')]: {
      width: drawerWidth,
      // backgroundColor: "#fff"
    },
  },
  title: {
    flexGrow: 1,
  },
  logo: {
    minWidth: '190px',
    padding: "3%",
    width: "80%"
    /* [theme.breakpoints.up('xs')]: {
      width: '50%',
    },
    [theme.breakpoints.up('sm')]: {
      width: '40%',
    },
    [theme.breakpoints.up('md')]: {
      width: '20%',
    }, */
    /* [theme.breakpoints.up('xs')]: {
      paddingTop: "3%"
    },
    [theme.breakpoints.up('sm')]: {
      paddingTop: "3%"
    },
    [theme.breakpoints.up('md')]: {
      paddingTop: "3%"
    },
    [theme.breakpoints.up('lg')]: {
      paddingTop: "3%"
    },
    [theme.breakpoints.up('xl')]: {
      paddingTop: "3%"
    }, */
  },
}));




const MenuDrawer = props => {
  const { open, closeDrawer, userState, window, userQuestions, pathCurrent,menuItems, identificationUser, devices, userDatePassword, handleOpenSnack, usernameChange } = props

  const classes = useStyles();
  const theme = useTheme();
  const [menuselectedsimple, setMenuselectedsimple] = useState("ESTADO DE CUENTA")
  const [menuselectedcollapse, setMenuselectedcollapse] = useState("");

  const mount = () => {
    const unmount = () => {

      //console.log(pathCurrent);

      if (menuselectedsimple === "PREGUNTAS DE SEGURIDAD") {
        switch (pathCurrent.pathname) {
          case "/":
            sendData("/", "ESTADO DE CUENTA")
            break;
          case "/password-change":
            sendData("/password-change", "CAMBIO DE CONTRASEÑA")
            break;
          default:
            break;
        }
      }

      if (userQuestions === 1) {
        sendData("/questions", "PREGUNTAS DE SEGURIDAD")
      }

      if ((pathCurrent.pathname === "/") && (menuselectedsimple === "CAMBIO DE CONTRASEÑA")) {
        sendData("/", "ESTADO DE CUENTA")
      }

      if ((pathCurrent.pathname === "/activityPayRole")) {
        sendData("/activityPayRole", "Consular nóminas")
      }

      if ((pathCurrent.pathname === "/username-change") && (menuselectedsimple === "CAMBIO DE CONTRASEÑA")) {
        setMenuselectedsimple("ESTADO DE CUENTA")
      }

    }
    return unmount()
  }

  useEffect(mount, [pathCurrent])


  //data => ruta
  //text => Nombre en el menu
  const sendData = (data, text) => {
    //console.log(data, text)

    //console.log(location)

    open && closeDrawer()
    //console.log(userQuestions)
    if (userQuestions === 1) {
      history.push('/questions')
    } else {
      if ((userState === 1) || (dateAfterLogin(userDatePassword))) {
        handleOpenSnack('COOP GAÑANSOL le recomienda cambiar su contraseña cada cierto tiempo por cuestiones de seguridad de su información.', 'info')
        history.push('/password-change')
      } else {
        setMenuselectedcollapse("")
        setMenuselectedsimple(text)
        history.push(data)
        const send = {
          type: 'paths',
          data
        }
        sendMobile(JSON.stringify(send))
      }
    }

  }

  const menuCollapseSelected = (text) => {
    //console.log(text);
    setMenuselectedsimple(text)
  }

  // const submenuCollapseSelected = (data, text, textfather) => {

  //   open && closeDrawer()
  //   if (userQuestions === 1) {
  //     history.push('/questions')
  //   } else {
  //     if (userState === 1) {
  //       history.push('/password-change')
  //     } else {
  //       setMenuselectedcollapse(text)
  //       setMenuselectedsimple(textfather)
  //       history.push(data)
  //     }
  //   }
  // }

  const dateAfterLogin = (str1) => {
    return new Date(str1) <= new Date();
}

  const submenuCollapseSelected = (data, text, textfather) => {

    open && closeDrawer()
    if (userQuestions === 1) {
      history.push('/questions')
    } else {
      if ((userState === 1) || (dateAfterLogin(userDatePassword))) {
        handleOpenSnack('COOP GAÑANSOL le recomienda cambiar su contraseña cada cierto tiempo por cuestiones de seguridad de su información.', 'info')
        history.push('/password-change')
      } else {
        if (usernameChange === 1) {
          history.push('/username-change')
        } else {
          setMenuselectedcollapse(text)
          setMenuselectedsimple(textfather)
          history.push(data)
        }
      }
    }
  }

  const container = window !== undefined ? () => window().document.body : undefined;
  return (
    <nav className={classes.drawer} aria-label="mailbox folders">
      <Hidden smUp implementation="css">
        <Drawer
          container={container}
          variant="temporary"
          anchor={theme.direction === 'rtl' ? 'right' : 'left'}
          open={open}
          onClose={closeDrawer}
          classes={{
            paper: classes.drawerPaper,
          }}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
        >
          <MenuHeader />
          <MenuItems identificationUser = {identificationUser} items={(menuItems !== undefined) ? menuItems : []} sendData={sendData} menuselectedsimple={menuselectedsimple} submenuCollapseSelected={submenuCollapseSelected}
          menuselectedcollapse={menuselectedcollapse} menuCollapseSelected={menuCollapseSelected} devices = {devices} />
        </Drawer>
      </Hidden>
      <Hidden xsDown implementation="css">
        <Drawer
          classes={{
            paper: classes.drawerPaper,
          }}
          variant="permanent"
          open
        >
          {/* <Typography component="div" className={classes.toolbar} style={{ backgroundColor: "#2E2757" }} align="center">
            <img src={process.env.PUBLIC_URL + '/images/logo_en_bn.png'} alt="Logo" className={classes.logo} />

           <img src={process.env.PUBLIC_URL + '/images/logo_san_jose_horizontal_web-removebg.png'} alt="Logo" height="90%" width="90%" className={classes.logo} />
          </Typography> */}
          <Typography
            variant="h6"
            noWrap
            className={classes.toolbar}
            style={{ display: 'flex', /* flexGrow: 1,  */backgroundColor: theme.palette.primary.main, justifyContent: "center" }}
          //align="center"
          >
            <img src={process.env.PUBLIC_URL + '/images/logo_en_bn_alt.svg'} alt="Logo" className={classes.logo} />

          </Typography>
          {/* <Divider component="li" style={{ backgroundColor: '#B48518', color: 'transparent', height:'6px' }} /> */}
          {/* <MenuItems style={{ color: '#FFFFFF' }} items={((menuItems !== undefined) ? menuItems : []).filter(item => item.web)} sendData={sendData} menuselectedsimple={menuselectedsimple}  */}
          <MenuItems identificationUser = {identificationUser} style={{ color: '#FFFFFF' }} items={((menuItems !== undefined) ? menuItems : [])} sendData={sendData} menuselectedsimple={menuselectedsimple}
          submenuCollapseSelected={submenuCollapseSelected} menuselectedcollapse={menuselectedcollapse} menuCollapseSelected={menuCollapseSelected} devices = {devices} />
        </Drawer>
      </Hidden>
    </nav>
  );
};

MenuDrawer.propTypes = {
  open: PropTypes.bool.isRequired,
  closeDrawer: PropTypes.func.isRequired,
};

export default MenuDrawer;

/*
    <div>
            <SwipeableDrawer
                anchor={anchor}
                open={open}
                onClose={closeDrawer}
                onOpen={closeDrawer}
            >
                <MenuHeader />
                <MenuItems anchor= {anchor}  items = { Items } sendData = { sendData } />
            </SwipeableDrawer>
        </div>

*/
